import React from 'react';
import { withRouter } from 'react-router-dom'


export default function VendorCard(props) {
  return (
    <div className="VendorCard">
      <img src={props.img} alt="Not available"/>
      <div className="vendor">{props.vendor}</div>
      <div className="price">{props.price}</div>
      <div className="eta">{props.eta}</div>
    </div>

  );
}